import api from '@/utils/api'

export default {
  methods: {
    handleError (res) { // 出错
      res = res.data || {}
      const status = (res.status && res.status.toLocaleLowerCase()) || ''
      let toName = ''
      let tip = ''
      let jump = false
      switch (status) {
        case 'no_login':
          window.location.href = api.getAdminLogin()
          break
        case 'params error':
          let errors = res.errors || {}
          let key = Object.keys(errors)[0]
          tip = '参数提交错误，请仔细检查，' + key + ': ' + errors[key]
          break
        case 'no_perm':
          tip = '权限不足'
          break
        case 'email dup':
          tip = '邮箱已存在，跳转至修改页'
          jump = {
            name: 'admin-update',
            params: {id: res.admin_id}
          }
          break
        default:
          tip = res.msg || '系统错误，请稍后再试'
      }
      if (toName) {
        this.$router.push({name: toName})
      } else if (tip) {
        this.$message.error(tip)
        if (jump) {
          let that = this
          setTimeout(() => {
            that.$router.push({name: jump.name, params: jump.params})
          }, 360)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/error.js